import { ApolloLink } from 'apollo-link'
import { ApolloClient, InMemoryCache } from '@apollo/client'
// import { InMemoryCache } from 'apollo-cache-inmemory'
import { createHttpLink } from 'apollo-link-http'
import { setContext } from 'apollo-link-context'
import { onError } from '@apollo/client/link/error'

import { cleanHeaderName, TOKEN_HEADER, REFRESH_TOKEN_HEADER } from 'utils'

const httpLink = createHttpLink({
	// @ts-ignore
	uri: process.env.REACT_APP_SUPABASE_URL + 'graphql/v1',
	headers: {
		apikey: process.env.REACT_APP_SUPABASE_ANON_KEY,
	},
})
const authLink = setContext((_, { headers }) => {
	const token = localStorage.getItem(cleanHeaderName(TOKEN_HEADER))
	const refreshToken = localStorage.getItem(
		cleanHeaderName(REFRESH_TOKEN_HEADER),
	)
	return {
		headers: {
			...headers,
			authorization: token && refreshToken ? `Bearer ${token}` : '',
		},
	}
})

// This properly catches auth errors
const errorLink = onError(({ networkError, graphQLErrors }) => {
	if (
		networkError &&
		'statusCode' in networkError &&
		networkError.statusCode === 401
	) {
		// Handle 401 unauthorized error
		localStorage.removeItem(cleanHeaderName(TOKEN_HEADER))
		localStorage.removeItem(cleanHeaderName(REFRESH_TOKEN_HEADER))
		window.location.href = '/'
	}

	if (graphQLErrors) {
		for (const err of graphQLErrors) {
			// You can also check for auth errors in GraphQL responses
			if (err.extensions?.code === 'UNAUTHENTICATED') {
				localStorage.removeItem(cleanHeaderName(TOKEN_HEADER))
				localStorage.removeItem(cleanHeaderName(REFRESH_TOKEN_HEADER))
				window.location.href = '/'
			}
		}
	}
})

const afterwareLink = new ApolloLink((operation, forward) => {
	return forward(operation)?.map(response => {
		const context = operation.getContext()
		const {
			response: { headers },
		} = context

		const token = headers?.get(cleanHeaderName(TOKEN_HEADER))
		const refreshToken = headers?.get(cleanHeaderName(REFRESH_TOKEN_HEADER))

		if (token) {
			localStorage.setItem(cleanHeaderName(TOKEN_HEADER), token)
		} else if (token === '') {
			localStorage.removeItem(cleanHeaderName(TOKEN_HEADER))
		}

		if (refreshToken) {
			localStorage.setItem(
				cleanHeaderName(REFRESH_TOKEN_HEADER),
				refreshToken,
			)
		} else if (refreshToken === '') {
			localStorage.removeItem(cleanHeaderName(REFRESH_TOKEN_HEADER))
		}

		return response
	})
})

const links = [errorLink, authLink, afterwareLink, httpLink]
const link = ApolloLink.from(links as unknown as ApolloLink[])

const client: any = new ApolloClient({
	link: link as any,
	// @ts-ignore
	cache: new InMemoryCache({
		// @ts-ignore
		dataIdFromObject: object => {
			switch (object.__typename) {
				case 'ActiveArticleTag':
					if (object.hasOwnProperty('uniqueIdentifier')) {
						// @ts-ignore
						return object.uniqueIdentifier
					}
					return object.id // use key as the primary key
				default:
					return object.id // fall back to id and _id for all other types
			}
		},
	}),
	connectToDevTools: true,
})

export default client
